<template>
  <div class="popup-virtual">
    <button
      class="popup-virtual__open"
      @click="gotoLink(link)"
    >
      {{translate('Virtuaaliesittely')}}

      <div
        class="popup-virtual__open-icon"
        :class="`popup-virtual__open-icon--${color}`"
      >
      <ChevronIcon />
      </div>
    </button>


  </div>
</template>

<script>
  import ChevronIcon from './icons/ChevronIcon.vue';
  import utils from './mixins/utils';

  export default {
    mixins: [utils.translate],
    props: {
        color: {
            type: String,
            default: "default",
        },
        link: {
            type: String,
            required: true,
        },
        floatLinksRight: {
            type: Boolean,
            default: false,
            required: false,
        }
    },
    data: () => ({
        open: false,
    }),
    methods: {
        gotoLink(link) {
            window.open(link);
        }
    },
    components: { ChevronIcon }
}
</script>

<style lang="scss">
  @import "~styles/definitions";

  .popup-virtual {
  }

  .popup-virtual__open {
    @include reset-button(true);
    @include font-label-16();
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:focus {
      text-decoration: underline;
    }

    .float-right {
      margin-left: auto;
    }
  }

  .popup-virtual__open-icon {
    margin-left: r(8);
    color: $color-green-2025;

    &--pink {
      color: $color-pink;
    }

    &--yellow {
      color: $color-yellow;
    }
  }

</style>
